import React, { Component } from 'react';
import { observable, action, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

import './signIn.scss';

@inject(({ teamUser }) => ({ doSignup: teamUser.doSignup }))
@observer
class SignUp extends Component {

  @observable teamUser = {
    userId: '',
    password: '',
    passwordConfirm: ''
  };
  @observable submitAttempted = false;

  @computed
  get passwordMismatch() {
    return (
      this.teamUser.password.length > 0 &&
      this.teamUser.passwordConfirm.length > 0 &&
      this.teamUser.password !== this.teamUser.passwordConfirm
    );
  }

  @action
  doSignUp = () => {
    this.submitAttempted = true;
    const _this = this;
    const params = {
      emailId: this.teamUser.userId,
      password: this.teamUser.password
    };

    if (!params.emailId || !params.password || !this.teamUser.passwordConfirm) {
      return;
    }
    if (params.password !== this.teamUser.passwordConfirm) {
      return;
    }

    this.props.doSignup(params, function (res) {
      if (res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      } else {
        _this.props.history.push('/signIn');
      }
    });
  };

  onChangeValue = (event) => {
    const { name, value } = event.target;
    this.teamUser[name] = value;
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.doSignUp();
    }
  };

  render() {
    const showMismatch = this.passwordMismatch;
    const showEmpty = this.submitAttempted && (
      !this.teamUser.userId || !this.teamUser.password || !this.teamUser.passwordConfirm
    );

    return (
      <section className="intro-section sign-section">
        <div className="intro-section__inner intro-section__inner--narrow sign-section__inner">
          <div className="sign-card">
            <div className="sign-card__head">
              <span className="sign-card__chip">
                <FeatherIcon icon="user-plus" size="13" />
                회원가입
              </span>
              <h1 className="sign-card__title">14일, 모든 기능을 무료로</h1>
              <p className="sign-card__desc">
                결제 정보 없이 바로 시작하실 수 있습니다.
              </p>
            </div>

            <form
              className="sign-form"
              onSubmit={(e) => { e.preventDefault(); this.doSignUp(); }}
            >
              <div className="sign-form__field">
                <label htmlFor="userId">이메일 아이디</label>
                <div className="sign-form__input-wrap">
                  <FeatherIcon icon="mail" size="15" className="sign-form__input-icon" />
                  <input
                    id="userId"
                    name="userId"
                    type="text"
                    autoComplete="email"
                    placeholder="example@onreple.co.kr"
                    value={this.teamUser.userId}
                    onChange={this.onChangeValue}
                    onKeyDown={this.handleKeyDown}
                  />
                </div>
              </div>

              <div className="sign-form__field">
                <label htmlFor="password">비밀번호</label>
                <div className="sign-form__input-wrap">
                  <FeatherIcon icon="lock" size="15" className="sign-form__input-icon" />
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="new-password"
                    placeholder="비밀번호를 입력해 주세요"
                    value={this.teamUser.password}
                    onChange={this.onChangeValue}
                    onKeyDown={this.handleKeyDown}
                  />
                </div>
              </div>

              <div className="sign-form__field">
                <label htmlFor="passwordConfirm">비밀번호 확인</label>
                <div className="sign-form__input-wrap">
                  <FeatherIcon icon="check-circle" size="15" className="sign-form__input-icon" />
                  <input
                    id="passwordConfirm"
                    name="passwordConfirm"
                    type="password"
                    autoComplete="new-password"
                    placeholder="비밀번호를 한 번 더 입력해 주세요"
                    value={this.teamUser.passwordConfirm}
                    onChange={this.onChangeValue}
                    onKeyDown={this.handleKeyDown}
                  />
                </div>
                {showMismatch && (
                  <p className="sign-form__error">
                    <FeatherIcon icon="alert-circle" size="13" />
                    비밀번호가 일치하지 않습니다.
                  </p>
                )}
                {showEmpty && !showMismatch && (
                  <p className="sign-form__error">
                    <FeatherIcon icon="alert-circle" size="13" />
                    모든 항목을 입력해 주세요.
                  </p>
                )}
              </div>

              <button type="submit" className="sign-form__submit">
                회원가입 <FeatherIcon icon="arrow-right" size="14" />
              </button>
            </form>

            <ul className="sign-card__hints">
              <li>1. 회원가입 후 카페24 쇼핑몰과 연동하면 즉시 사용할 수 있습니다.</li>
              <li>2. 카페24 앱스토어를 통해 가입하시면 자동 연동이 진행됩니다.</li>
              <li>
                <span className="sign-card__hint-tag">개인정보</span>
                온리플은 운영에 꼭 필요한 정보만 안전하게 보관합니다.
              </li>
            </ul>

            <div className="sign-card__foot sign-card__foot--split">
              <span className="sign-card__foot-text">이미 계정이 있으신가요?</span>
              <Link to="/signIn" className="sign-card__foot-link">
                로그인 <FeatherIcon icon="arrow-right" size="13" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SignUp;
